import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { class_type, record_type, decimal_type, list_type, bool_type, obj_type, lambda_type, unit_type, union_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { GlobalMsg, GlobalMessageBox_Error_Z721C83C5, GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { Dashboard_MeineZahlen_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { toArray, length, ofArray, map, sum, empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { createObj, equals, int32ToString, uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { toNumber, op_Addition, fromParts } from "../../../fable_modules/fable-library-js.4.19.0/Decimal.js";
import Decimal from "../../../fable_modules/fable-library-js.4.19.0/Decimal.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { request } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../../../fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { defaultArg, value as value_32 } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/./Fable.React.UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/../Fable.Elmish.4.2.0/program.fs.js";
import { bfsTile } from "../Shared/Tile.fs.js";
import { Option, button } from "../../../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { RechartExtensions_bar_radius, RechartExtensions_tooltip_labelFormatter, RechartExtensions_tooltip_cursor, RechartExtensions_yAxis_tick, RechartExtensions_yAxis_stroke, RechartExtensions_xAxis_stroke, CustomColors_bfsOrange } from "../../../../Bfs.Web.Portale/Helpers.fs.js";
import { Size_ISize, Color_IColor } from "../../../fable_modules/Fulma.3.0.0/Common.fs.js";
import * as react from "react";
import { spinner } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { asMoneyFloat, asMoney } from "../../../../Bfs.Web.Data.Service.Contracts/Shared.fs.js";
import { getCharAtIndex } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { reactApi } from "../../../fable_modules/Feliz.Recharts.4.3.0/../Feliz.2.9.0/Interop.fs.js";
import { ResponsiveContainer, BarChart, Bar, Cell, Tooltip, YAxis, XAxis } from "recharts";
import { reactApi as reactApi_1 } from "../../../fable_modules/Feliz.2.9.0/./Interop.fs.js";

export class DataToDisplay extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Volumen", "Zahlungen"];
    }
}

export function DataToDisplay_$reflection() {
    return union_type("Dashboard.MeineZahlungen.DataToDisplay", [], DataToDisplay, () => [[], []]);
}

export class Model extends Record {
    constructor(GlobalDispatch, NavigateTo, Loading, Data, DataToDisplay, VolumenTotal, ZahlungenTotal) {
        super();
        this.GlobalDispatch = GlobalDispatch;
        this.NavigateTo = NavigateTo;
        this.Loading = Loading;
        this.Data = Data;
        this.DataToDisplay = DataToDisplay;
        this.VolumenTotal = VolumenTotal;
        this.ZahlungenTotal = ZahlungenTotal;
    }
}

export function Model_$reflection() {
    return record_type("Dashboard.MeineZahlungen.Model", [], Model, () => [["GlobalDispatch", lambda_type(GlobalMsg_$reflection(), unit_type)], ["NavigateTo", lambda_type(obj_type, unit_type)], ["Loading", bool_type], ["Data", list_type(Dashboard_MeineZahlen_$reflection())], ["DataToDisplay", DataToDisplay_$reflection()], ["VolumenTotal", decimal_type], ["ZahlungenTotal", decimal_type]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadData", "LoadDataCompleted", "SwitchDataToDisplay"];
    }
}

export function Msg_$reflection() {
    return union_type("Dashboard.MeineZahlungen.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(Dashboard_MeineZahlen_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", list_type(Dashboard_MeineZahlen_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", DataToDisplay_$reflection()]]]);
}

export function Http_loadAnstehendeZahlungen() {
    const response = fetch("/api/dashboard/meine-zahlen", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(list_type(Dashboard_MeineZahlen_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function State_init(props) {
    return [new Model(props.GlobalDispatch, props.NavigateTo, true, empty(), new DataToDisplay(0, []), fromParts(0, 0, 0, false, 0), fromParts(0, 0, 0, false, 0)), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

export function State_update(msg, model) {
    switch (msg.tag) {
        case 1:
            if (msg.fields[0].tag === 1) {
                model.GlobalDispatch(new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5("Ihre Zahlen können zur Zeit leider nicht geladen werden.")]));
                return [new Model(model.GlobalDispatch, model.NavigateTo, false, model.Data, model.DataToDisplay, model.VolumenTotal, model.ZahlungenTotal), Cmd_none()];
            }
            else {
                return [new Model(model.GlobalDispatch, model.NavigateTo, false, msg.fields[0].fields[0], model.DataToDisplay, sum(map((x) => x.Volumen, msg.fields[0].fields[0]), {
                    GetZero: () => (new Decimal("0")),
                    Add: op_Addition,
                }), sum(map((x_2) => x_2.Zahlungen, msg.fields[0].fields[0]), {
                    GetZero: () => (new Decimal("0")),
                    Add: op_Addition,
                })), Cmd_none()];
            }
        case 2:
            return [new Model(model.GlobalDispatch, model.NavigateTo, model.Loading, model.Data, msg.fields[0], model.VolumenTotal, model.ZahlungenTotal), Cmd_none()];
        default:
            return [new Model(model.GlobalDispatch, model.NavigateTo, false, model.Data, model.DataToDisplay, model.VolumenTotal, model.ZahlungenTotal), request(Http_loadAnstehendeZahlungen, undefined, (Item) => (new Msg(1, [Item])))];
    }
}

export const View = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_32("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\WebParts\\User\\Dashboard\\MeineZahlen.fs") + "#L") + int32ToString(value_32(79))) + ";") + "Dashboard.Shared.DashboardProps", value_32("View"), (props) => {
    let children, children_14, children_10, children_8, children_4, children_12, properties_6, value_1, properties_5, elements_1, properties, properties_1, properties_2, properties_4, elements;
    let patternInput;
    const init = State_init(props);
    patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, State_update, (_arg, _arg_1) => {
    }), undefined, undefined);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    return bfsTile("Meine Zahlen", model_1.Loading ? undefined : ((children = [button(ofArray([new Option(0, [equals(model_1.DataToDisplay, new DataToDisplay(0, [])) ? CustomColors_bfsOrange : (new Color_IColor(3, []))]), new Option(1, [new Size_ISize(0, [])]), new Option(18, [(_arg_2) => {
        dispatch(new Msg(2, [new DataToDisplay(0, [])]));
    }]), new Option(19, ["is-rounded"])]), singleton("Sendungswert")), button(ofArray([new Option(0, [equals(model_1.DataToDisplay, new DataToDisplay(1, [])) ? CustomColors_bfsOrange : (new Color_IColor(3, []))]), new Option(1, [new Size_ISize(0, [])]), new Option(18, [(_arg_3) => {
        dispatch(new Msg(2, [new DataToDisplay(1, [])]));
    }]), new Option(19, ["is-rounded"])]), singleton("Zahlungen"))], react.createElement("div", {
        className: "block",
    }, ...children))), undefined, model_1.Loading ? spinner : ((children_14 = [(children_10 = ((model_1.DataToDisplay.tag === 1) ? ofArray([react.createElement("div", {
        className: "large",
    }, "Erhaltene Zahlungen"), (children_8 = [`In den vergangenen ${length(model_1.Data)} Monaten haben Sie Gesamtzahlungen in Höhe von ${asMoney(model_1.ZahlungenTotal)} erhalten.`], react.createElement("div", {
        className: "subtle",
    }, ...children_8))]) : ofArray([react.createElement("div", {
        className: "large",
    }, "Sendungswert"), (children_4 = [`In den vergangenen ${length(model_1.Data)} Monaten haben Sie Sendungen im Wert von ${asMoney(model_1.VolumenTotal)} eingereicht.`], react.createElement("div", {
        className: "subtle",
    }, ...children_4))])), react.createElement("div", {
        className: "meine-zahlen-description",
        key: "meine-zahlen-description",
    }, ...children_10)), (children_12 = [(properties_6 = ofArray([(value_1 = (100 + "%"), (equals(value_1, 100 + "%") ? true : equals(value_1, 100 + "%")) ? ["width", 99 + "%"] : ["width", value_1]), ["height", 190], ["children", (properties_5 = ofArray([["margin", {
        top: defaultArg(0, 0),
        right: defaultArg(0, 0),
        left: defaultArg(0, 0),
        bottom: defaultArg(0, 0),
    }], ["data", toArray(model_1.Data)], ["width", 500], ["height", 190], (elements_1 = ofArray([(properties = ofArray([["dataKey", (point) => {
        let copyOfStruct = getCharAtIndex(point.Monat, 0);
        return copyOfStruct;
    }], ["tick", {
        fill: "lightgrey",
        fontSize: 12,
    }], RechartExtensions_xAxis_stroke("transparent")]), reactApi.createElement(XAxis, createObj(properties))), (properties_1 = ofArray([["tickCount", 4], RechartExtensions_yAxis_stroke("transparent"), RechartExtensions_yAxis_tick({
        fill: "lightgrey",
        fontSize: 12,
    })]), reactApi.createElement(YAxis, createObj(properties_1))), (properties_2 = ofArray([["formatter", (delegateArg, delegateArg_1, delegateArg_2) => {
        const props_13 = delegateArg_2;
        return [asMoneyFloat(delegateArg), props_13.payload.Monat, props_13];
    }], RechartExtensions_tooltip_cursor({
        fill: "#EEE",
    }), RechartExtensions_tooltip_labelFormatter((_arg_5) => "")]), reactApi.createElement(Tooltip, createObj(properties_2))), (properties_4 = ofArray([["dataKey", (point_1) => toNumber((model_1.DataToDisplay.tag === 1) ? point_1.Zahlungen : point_1.Volumen)], RechartExtensions_bar_radius([10, 10, 0, 0]), ["barSize", 15], (elements = map((data) => {
        const properties_3 = ofArray([["fill", data.IstLetztesJahr ? "lightgray" : "gray"], ["key", data.Monat]]);
        return reactApi.createElement(Cell, createObj(properties_3));
    }, model_1.Data), ["children", ["children", reactApi_1.Children.toArray(Array.from(elements))]])]), reactApi.createElement(Bar, createObj(properties_4)))]), ["children", reactApi_1.Children.toArray(Array.from(elements_1))])]), reactApi.createElement(BarChart, createObj(properties_5)))]]), reactApi.createElement(ResponsiveContainer, createObj(properties_6)))], react.createElement("div", {
        className: "meine-zahlen-chart",
        key: "meine-zahlen-chart",
    }, ...children_12))], react.createElement("div", {
        className: "meine-zahlen",
    }, ...children_14))), undefined);
}, undefined, undefined, "Of");

//# sourceMappingURL=MeineZahlen.fs.js.map
